/* eslint-disable no-alert */
import axios from 'axios';
import {action, observable} from 'mobx';
import Toast from '../../../components/Toast';

// const mockData = require('./mock.json');

const dataApi = '/zts/2019_viking/touch_ajax.php?clean_cache=1';
const appointApi = '/zts/2019_viking/ajax.php';

class Store {
    @observable popupType = ''; // 弹框 id
    @observable curVideoUrl = '';
    @observable allData = {};

    // 预约信息
    @observable appointForm = {
        username: '',
        tel: ''
    };
    // 展示弹窗
    @action.bound showPopup(type, url = '') {
        this.popupType = type;
        this.curVideoUrl = url;
        this.stopBodyScroll(true);
    }
    // 关闭弹窗
    @action.bound hidePopup() {
        this.popupType = '';
        this.curVideoUrl = '';
        this.stopBodyScroll(false);
    }
    // flag -> true/false  阻止/允许页面滚动
    @action.bound stopBodyScroll(flag) {
        if (flag) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'visible';
        }
    }
    // 提交表单
    @action.bound changeAppointForm(key, evt) {
        this.appointForm[key] = evt.target.value;
    }

    // 请求数据
    @action.bound requestData() {
        axios.get(dataApi).then(res => {
            const {ret, data} = res.data;
            if (ret) {
                this.allData = data;
            }
        });
    }
    // 预约
    @action.bound requestAppoint() {
        const {username, tel} = this.appointForm;
        if (!username || !tel) {
            return;
        }
        axios
            .get(appointApi, {
                params: {
                    action: 'add',
                    username,
                    tel
                }
            })
            .then(res => {
                if(res.data.message === 'success') {
                    Toast.show('预约成功，我们会尽快联系您~');
                } else {
                    Toast.show('小骆驼没有收到信息，请再提交一下~');
                }
            });
    }
}

export default new Store();
